import type { ComposerDraftKey, ComposerDraftScope } from "./types";

export const buildComposerDraftKey = (
  scope: ComposerDraftScope,
): ComposerDraftKey => {
  const common = [
    "composer-draft",
    "v1",
    scope.kind,
    scope.userId,
    scope.studyGroupId,
  ];
  const parts =
    scope.kind === "post"
      ? [...common, scope.channelKey]
      : scope.kind === "comment"
        ? [...common, scope.postId]
        : [
            ...common,
            scope.postId,
            scope.parentCommentId,
            scope.anchorCommentId,
          ];

  return JSON.stringify(parts) as ComposerDraftKey;
};
